import request from '@/utils/request';
import router from '@/router';
import { rolesRedirectPages } from '@/router/guard';

export default {
    login: async({ state, dispatch, commit }, user) => {
        if (state.operator) {
            return;
        }

        await request({ method: 'post', url: '/login', data: user })
            .then(res => {
                if (res.data) {
                    commit('SET_OPERATOR', res.data);

                    router.push(rolesRedirectPages[res.data.user.roleName]);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getUser: async({ state, commit }) => {
        if (state.operator) {
            return;
        }

        await request({ method: 'get', url: '/account' })
            .then(res => {
                if (res.data) {
                    commit('SET_OPERATOR', res.data);
                }
            }).catch(() => {
                // No need
            });
    },

    logout: async({ dispatch, commit }) => {
        await request({ method: 'post', url: '/logout' })
            .then(res => {
                if (res.data) {
                    commit('SET_OPERATOR', null);

                    dispatch('getUser');
                }
            }).catch(() => {
                // if(error.response && error.response.data && error.response.data.error) {
                //     dispatch('alert/addMessage', {
                //         message: error.response.data.error
                //     }, { root: true });
                // }
            });
    }
};
